import Swal from "sweetalert2";
import Apiauth from "../api/Apiauth";
import Apibank from "../api/Apibank";
import {  openNotification, sendApiTelegram_activity, sendApiTelegram_call_api_error } from "../utils";
import { handleCheckError } from "./fetchData";
import { message } from "antd";

/**
 * @param {number} id - รหัส ID ที่ต้องการประมวลผล
 */
export const getFuncReSend = async (id) => {

  try {
    const res = await Apibank.getReSend({ id });
    if (res.data.success) {
      openNotification("success", "successful", res.data.message);
      return true;
    } else {
      console.error(`An error occurred. ${res.status || ""}`, res.data.message);
      openNotification("error", "Failed to re-send", res.data.message);
      return false;
    }
  } catch (error) {
    console.error("Failed to re-send:", error.message);
    sendApiTelegram_call_api_error(error, "getFuncReSend");
    return false;
  }
};

export const getFuncConfirmTransaction = async (data) => {
  try {
    const res = await Apibank.getConfirmTransaction(data);
    if (res?.status === 200) {
      openNotification(
        "success",
        `statusCode: ${res?.status}`,
        res.data.status
      );
      return res.data;
    } else {
      console.error(`An error occurred. ${res.status || ""}`, res.data.note);
      Swal.fire({
        title: `statusCode: ${res?.status}`,
        text: res.data.note,
        icon: "error",
      });
      return false;
    }
  } catch (error) {
    console.error("Failed:", error);
    sendApiTelegram_call_api_error(error, "getFuncConfirmTransaction");
    let errorTxt = error?.response?.data?.error || error.message;
    Swal.fire({
      title: `statusCode: ${error?.status}`,
      text: errorTxt,
      icon: "error",
    });
    return false;
  }
};

export const getFuncCheckStatusTransection = async (data, nofData) => {
  try {
    const res = await Apiauth.getUpdate_withdraw(data);
    sendApiTelegram_activity(res, "REJECTED", nofData?.details, nofData?.resProfileAdmin);

    if (res.data.success) {
      openNotification("success", "สำเร็จ", res.data.message);
      return res.data;
    } else {
      console.error(`An error occurred. ${res.status || ""}`, res.data.message);
      openNotification("error", "Failed", res.data.message);
      console.log(`An error occurred. ${res.status || ""}`, res.data.message);
      return false;
    }
  } catch (error) {
    sendApiTelegram_call_api_error(error, "getFuncCheckStatusTransection");
    let errTxt = error.message;
    if (error?.response?.data?.message) {
      errTxt = error?.response?.data?.message;
      message.error({
        content: errTxt,
        duration: 4.5,
      });
      return false;
    }
    console.error("Failed to re-send:", error);
    handleCheckError(error, `getFuncCheckStatusTransection`);
    return false;
  }
};

export const getFuncBalance = async (id) => {
  try {
    const res = await Apibank.get_balance_summery({ id: id });
    if (res.data.success) {
      openNotification("success", "สำเร็จ", res.data.message);
      return res.data;
    } else {
      openNotification("error", "Failed", res.data.message);
      console.log(`An error occurred. ${res.status || ""}`, res.data.message);
      return false;
    }
  } catch (error) {
    let errTxt = error.message;
    if (error.status === 500 && error?.response?.data?.message) {
      errTxt = error?.response?.data?.message;
      message.error({
        content: `error ${error.status} : ${errTxt}`,
        duration: 5.5,
      });
      return false;
    }
    console.error("Failed to re-send:", error);
    sendApiTelegram_call_api_error(error, "getFuncBalance");
    handleCheckError(error, `getFuncBalance`);
    return false;
  }
};

export const getFuncSearchCustomer = async (postData) => {
  try {
    const res = await Apiauth.getSearchCustomer(postData);
    if (res.data.success) {
      openNotification("success", "สำเร็จ", res.data.message);
      return res.data;
    } else {
      openNotification("error", `Failed`, res.data.message);
      console.error(`An error occurred. ${res.status || ""}`, res.data.message);
      return false;
    }
  } catch (error) {
    sendApiTelegram_call_api_error(error, "getFuncSearchCustomer");
    console.error("Failed to re-send:", error.message);
    handleCheckError(error, `getFuncSearchCustomer`);
    return false;
  }
};
